import useBroadcastChannel from 'hooks/useBroadcastChannel';
import { IHistoryRecord } from 'app/app/editor/useHistory';

export type MessageType =
    | 'dropComponent'
    | 'stateChange'
    | 'reloadPage'
    | 'editComponent'
    | 'dragStart'
    | 'dragEnd'
    | 'updateComponent'
    | 'changeContainerSize'
    | 'changeComponentSettings'
    | 'showHistory'
    | 'updateCssVariables';
export interface IBroadcastMessage {
    name: MessageType;
    data?: any;
    broadcast?: boolean;
}

export interface DropComponentData {
    target: {
        containerId: string;
        componentAfterId: string;
        dropPath: Array<string>;
    };
    data: {
        type: string;
    };
}
export interface IBroadcastMessageDropComponent extends IBroadcastMessage {
    name: 'dropComponent';
    data: DropComponentData;
}

export interface IBroadcastMessageEditComponent extends IBroadcastMessage {
    name: 'editComponent';
    data: { uid: string | null; querySelector: string | null };
}

export interface IBroadcastMessageUpdateComponent extends IBroadcastMessage {
    name: 'updateComponent';
    data: { updateType: 'style' | 'settings' | 'both'; uid: string };
}

export interface IBroadcastMessageEmpty extends IBroadcastMessage {
    name: 'stateChange' | 'reloadPage';
}

export interface IBroadcastMessageDrag extends IBroadcastMessage {
    name: 'dragStart' | 'dragEnd';
    data: { type: string };
}

export interface IBroadcastMessageChangeContainerSize extends IBroadcastMessage {
    name: 'changeContainerSize';
    data: { uid: string; width: number; height: number };
}

export interface IBroadcastMessageChangeComponentSettings<T> extends IBroadcastMessage {
    name: 'changeComponentSettings';
    data: { uid: string; settings: T };
}

export interface IBroadcastMessageShowHistory extends IBroadcastMessage {
    name: 'showHistory';
    data: IHistoryRecord | null;
}

export interface IBroadcastMessageUpdateCssVariables extends IBroadcastMessage {
    name: 'updateCssVariables';
}

export type BroadcastMessageType =
    | IBroadcastMessageDropComponent
    | IBroadcastMessageEditComponent
    | IBroadcastMessageUpdateComponent
    | IBroadcastMessageDrag
    | IBroadcastMessageEmpty
    | IBroadcastMessageChangeContainerSize
    | IBroadcastMessageChangeComponentSettings<any>
    | IBroadcastMessageShowHistory
    | IBroadcastMessageUpdateCssVariables;

export default function useAppEditorChannel(channelName: string) {
    return useBroadcastChannel<BroadcastMessageType>(channelName);
}
